/**
 * @generated SignedSource<<b4591c102e57a56689d9a3bad77a0852>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InternBrandStyleImageType = "IMG" | "SVG" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InternBrandStyleLogo_brand$data = {
  readonly appConfig: {
    readonly buildTheme: {
      readonly id: string;
      readonly logoUrl: string | null;
    };
    readonly id: string;
  };
  readonly id: string;
  readonly internStyle: {
    readonly logos: ReadonlyArray<{
      readonly height: number | null;
      readonly html: string;
      readonly src: string | null;
      readonly type: InternBrandStyleImageType;
      readonly width: number | null;
    }>;
  } | null;
  readonly " $fragmentType": "InternBrandStyleLogo_brand";
};
export type InternBrandStyleLogo_brand$key = {
  readonly " $data"?: InternBrandStyleLogo_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStyleLogo_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStyleLogo_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InternBrandStyle",
      "kind": "LinkedField",
      "name": "internStyle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleImage",
          "kind": "LinkedField",
          "name": "logos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "src",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "html",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "d31fa66d5cc6c3d46edf432553045b54";

export default node;
